import * as React from "react";
import { forwardRef } from "react";

const SvgBoto3 = ({
  title,
  titleId,
  ...props
}, ref) => <svg width="94.323959mm" height="106.91389mm" viewBox="0 0 94.32396 106.91389" id="svg5" xmlSpace="preserve" sodipodi:docname="boto3.svg" inkscape:export-filename="boto3.svg" inkscape:export-xdpi={96} inkscape:export-ydpi={96} xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<sodipodi:namedview id="namedview7" pagecolor="#ffffff" bordercolor="#000000" borderopacity={0.25} inkscape:showpageshadow={2} inkscape:pageopacity={0} inkscape:pagecheckerboard={0} inkscape:deskcolor="#d1d1d1" inkscape:document-units="mm" showgrid="false" showguides="true" /><defs id="defs2" localstack-color="#ffd640" /><g inkscape:groupmode="layer" id="layer2" inkscape:label="Base Layer" style={{
    display: "inline"
  }} transform="translate(-43.449458,-60.863291)"><path id="outside-box" style={{
      color: "#000000",
      display: "inline",
      fill: "#000000",
      strokeMiterlimit: 11.7,
      InkscapeStroke: "none"
    }} d="M 90.711172,60.863291 43.572448,87.691628 v 0.675411 l -0.12299,52.375101 47.367134,27.03504 46.956828,-26.90224 -0.20878,-53.392602 z m 0,2.679423 43.362728,24.634672 -19.65616,11.022066 1.10484,0.760161 0.0362,1.270727 19.68666,-11.040157 0.19378,49.337037 -43.53946,24.94473 -0.02687,-22.38984 -1.176156,0.61185 -1.151868,-0.60979 0.02687,22.29993 -43.790609,-24.9933 0.114722,-49.253327 19.334737,10.743527 0.04547,-1.267103 1.087273,-0.769979 -19.06602,-10.592635 z" /><g id="orange-box"><path style={{
        fill: "#ffd640",
        fillOpacity: 1,
        strokeWidth: 0.529167,
        strokeMiterlimit: 11.7
      }} d="m 67.288826,102.34724 0.02716,24.3219 22.179113,13.62883 0.08212,-25.35233 z" id="left-orange" sodipodi:nodetypes="ccccc" /><path style={{
        fill: "#ffd640",
        fillOpacity: 1,
        strokeWidth: 0.529167,
        strokeMiterlimit: 11.7
      }} d="m 91.9151,114.74793 0.01934,25.51941 22.01921,-12.74743 -0.0349,-25.23448 z" id="right-orange" sodipodi:nodetypes="ccccc" /><path style={{
        fill: "#ffd640",
        fillOpacity: 1,
        strokeWidth: 0.529167,
        strokeMiterlimit: 11.7
      }} d="M 69.163519,100.44626 90.737469,112.6385 112.45981,100.30309 90.643942,88.197652 Z" id="top-orange" sodipodi:nodetypes="ccccc" /></g></g></svg>;

const ForwardRef = forwardRef(SvgBoto3);
export default ForwardRef;